<template>
    <div class="pagination">
        <b-pagination-nav use-router :number-of-pages="10" :link-gen="linkGen" />
    </div>
</template>

<script>
export default {
    name: "Pagination",
    methods: {
        linkGen() {
            return '#'; 
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partial';
</style>
